/* eslint-disable react/jsx-no-bind */
import React, { FC, memo, useRef } from 'react';
import { noop } from 'lodash';
// Import Enums
import { SaveModesEnum } from 'enums';
// Import components
import { ResetSave } from 'components';

interface Props {
    disableSave?: boolean;
    disableReset?: boolean;
    hasAdditionalSettings?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    buttonWithDropDownConfig?: Record<string, any>;
    handleSave?: (mode: SaveModesEnum) => void;
    handleReset?: () => void;
    handleTestSend?: () => void;
    setSaveButtonLabel: (mode: SaveModesEnum) => void;
}

const PageHeadlineActionBar: FC<Props> = (props) => {
    const {
        disableSave = false,
        disableReset = false,
        hasAdditionalSettings = false,
        buttonWithDropDownConfig = {},
        handleSave = noop,
        handleReset = noop,
        handleTestSend,
        setSaveButtonLabel,
    } = props;
    const modeRef = useRef({});

    const setMode = (mode) => {
        modeRef.current = mode;
        setSaveButtonLabel(mode);
    };

    const saveButtonClickHandler = () => {
        handleSave(modeRef.current);
    };

    const resetButtonClickHandler = () => {
        handleReset();
    };

    return (
        <div className="crm-page-headline_button-box">
            <ResetSave
                disableReset={disableReset}
                disableSave={disableSave}
                hasAdditionalSettings={hasAdditionalSettings}
                buttonWithDropDownConfig={buttonWithDropDownConfig}
                setMode={setMode}
                testSendButtonClickHandler={handleTestSend}
                saveButtonClickHandler={saveButtonClickHandler}
                resetButtonClickHandler={resetButtonClickHandler}
            />
        </div>
    );
};

export default memo(PageHeadlineActionBar);
